/** Where each brand image appears, in the order Admin Center → Branding lists them. */
export interface BrandSlot {
  key: string;
  label: string;
  usedFor: string;
  /** Recommended size, in pixels. */
  size: string;
  /** The preview sits on a dark background (images meant for navy). */
  dark?: boolean;
}

export const BRAND_SLOTS: BrandSlot[] = [
  { key: "logo", label: "Logo", usedFor: "Sign-in screens and emails, on light backgrounds", size: "1400 × 350" },
  { key: "logo-dark", label: "Logo for dark backgrounds", usedFor: "Sign-in screens in dark mode and the brand panel", size: "1000 × 260", dark: true },
  { key: "icon", label: "Icon", usedFor: "The menu and QR cards, on light backgrounds", size: "512 × 512" },
  { key: "icon-dark", label: "Icon for dark backgrounds", usedFor: "The menu in dark mode", size: "512 × 512", dark: true },
  { key: "icon-accent", label: "Accent icon", usedFor: "The footer", size: "512 × 512" },
  { key: "favicon", label: "Browser tab icon", usedFor: "The suite's and the website's browser tabs", size: "32 × 32" },
  { key: "touch-icon", label: "Home screen icon", usedFor: "Phones that add the website to their home screen", size: "180 × 180" },
  { key: "social", label: "Link preview image", usedFor: "When a link to the suite or the website is shared", size: "1200 × 630" },
];

export const BRAND_FILE_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const BRAND_MAX_BYTES = 2 * 1024 * 1024;

/** Why a file can't be used as a brand image, or null when it can. */
export function brandFileProblem(file: { type: string; size: number }): string | null {
  if (!BRAND_FILE_TYPES.includes(file.type)) return "Use a PNG, JPEG or WebP image.";
  if (file.size > BRAND_MAX_BYTES) return "The image is bigger than 2 MB.";
  return null;
}

/** The public URL of a slot's image; `version` makes the browser fetch a replaced image again. */
export function brandImageUrl(slot: string, version?: string): string {
  return `/api/branding/${slot}${version ? `?v=${encodeURIComponent(version)}` : ""}`;
}
